<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <VuePerfectScrollbar class="technic-scroll-area" :settings="settings">
    <div id="page-user-view">
      <div id="user-data" v-if="viewData" style="height: 500px;">
        <vx-card class="mb-base">
          <div class="vx-row mb-12 ml-0">
            <vs-button
              icon-pack="feather"
              icon="icon-skip-back"
              color="success"
              class="mr-4"
              type="border"
              :to="{name: 'PayCard'}"
            ></vs-button>
            <h3 class="mt-2">Müşteri Bilgileri</h3>
          </div>

          <!-- Avatar -->
          <div class="vx-row">
            <!-- Avatar Col -->
            <div class="vx-col" id="avatar-col">
              <div class="img-container mb-4">
                <img
                  :src="viewData.avatar?viewData.avatar:this.$defaultPicture"
                  class="rounded w-full"
                />
              </div>
            </div>

            <!-- Information - Col 1 -->
            <div class="vx-col flex-1" id="account-info-col-1">
              <table>
                <tr>
                  <td class="font-semibold">Adı Soyadı:</td>
                  <td>{{viewData.firstName}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Telefon:</td>
                  <td>
                    <a
                    target="_blank"
                    v-bind:href="beautifyPhone()"
                  >{{viewData.phone}}</a>
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Email:</td>
                  <td>
                    <a
                    v-bind:href="'mailto:' + viewData.email"
                     >{{viewData.email}}</a>
                    </td>
                </tr>
                <tr>
                  <td class="font-semibold">Üyelik Tarihi:</td>
                  <td>{{viewData.createdDate}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Müşteri Hesap:</td>
                  <td id="amount"></td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 1 -->

            <!-- Information - Col 2 -->
            <div class="vx-col flex-1" id="account-info-col-2">
              <table>
                <tr>
                  <td class="font-semibold">Müşteri Temsilcisi:</td>
                  <td>{{ viewData.addUserID }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Bölge:</td>
                  <td>{{ viewData.detailNote }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Etiket:</td>
                  <td>{{ viewData.detailNote }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Müşteriye Puanınız:</td>
                  <td>
                    <star-rating @rating-selected="setRating" :rating="3" :star-size="20"></star-rating>
                  </td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 2 -->
            <div class="vx-col justify-end w-full flex" id="account-manage-buttons">
              <vs-button
                icon-pack="feather"
                icon="icon-edit"
                class="mr-4"
                :to="{name: 'contactsEdit', params: { contactsId: $route.params.contactsId }}"
              >Düzenle</vs-button>

              <vs-button
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                @click="confirmDeleteRecord()"
              >Sil</vs-button>
            </div>
          </div>
        </vx-card>

        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full">
            <vx-card class="mb-base">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="flex items-end px-3">
                    <feather-icon svgClasses="w-6 h-6" icon="PhoneCallIcon" class="mr-2" />
                    <span class="font-medium text-lg leading-none">İletişim Bilgileri</span>
                  </div>
                  <vs-divider />
                </div>
              </div>
              <table>
                <tr>
                  <td class="font-semibold">Dil:</td>
                  <td>{{ viewData.gender }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Telefon(2):</td>
                  <td>{{ viewData.dob }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Teslimat Adresi:</td>
                  <td>{{ viewData.address }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Fatura Adresi:</td>
                  <td>{{ viewData.billingAddress }}</td>
                </tr>
              </table>
            </vx-card>
          </div>

          <div class="vx-col lg:w-1/2 w-full">
            <vx-card class="mb-base">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="flex items-end px-3">
                    <feather-icon svgClasses="w-6 h-6" icon="CreditCardIcon" class="mr-2" />
                    <span class="font-medium text-lg leading-none">Hesap Bilgileri ve Yorumlar</span>
                  </div>
                  <vs-divider />
                </div>
              </div>
              <table>
                <tr>
                  <td class="font-semibold">Vergi No:</td>
                  <td>{{ viewData.taxNumber }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Vergi Dairesi:</td>
                  <td>{{ viewData.taxName }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Müşteri Hakkında:</td>
                  <td>{{ viewData.detailNote }}</td>
                </tr>
                 
                <tr>
                  <td class="font-semibold">Müşteri Genel Puanı:</td>
                  <td>{{ viewData.stars }}</td>
                </tr>
              </table>
            </vx-card>
          </div>
        </div>

        <vx-card class="mb-base">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <feather-icon svgClasses="w-6 h-6" icon="BookOpenIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">Geçmiş Alışverişler</span>
              </div>
              <vs-divider />
            </div>
          </div>

          <div class="block overflow-x-auto tableHeight">
            <table class="w-full">
              <tr>
                <th
                  class="font-semibold text-base text-left px-3 py-2"
                  v-for="heading in ['Siparis No', 'Fiyat', 'Ödeme Şekli', 'Tarih', 'Alacak/Verecek']"
                  :key="heading"
                >{{ heading }}</th>
              </tr>

              <tr v-for="row in sampleData" :key="row.name">
                <td class="px-3 py-2">{{ row.name }}</td>
                <td v-for="value in row.val" class="px-3 py-2" :key="value">
                  <span>{{value}}</span>
                </td>
              </tr>
            </table>
          </div>
        </vx-card>

        <vx-card class="mb-base">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <feather-icon svgClasses="w-6 h-6" icon="VoicemailIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">Müşteri Aksiyonları</span>
              </div>
              <vs-divider />
              <div class="block overflow-x-auto tableHeight">
                <table class="w-full">
                  <tr>
                    <td>
                      <b style="background-color:#9df69d;">Gelen Arama:</b> 13/06/2020 tarihinde arandı
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Halil İbrahim Takıl:</b>
                      <u>İyi iletişim kuralım</u> (12/12/2019)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b style="background-color:#9df69d;">Gelen Arama:</b> 13/06/2020 tarihinde arandı
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>İlker Kaya:</b>
                      <u>Cana yakın ve sevecen biri</u> (05/02/2020)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b style="background-color:#fc9c9c;">Cevapsız Arama:</b>13/06/2020 tarihinde arandı
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b style="background-color:DeepSkyBlue;">Giden Arama:</b> 13/06/2020 tarihinde arandı
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b style="background-color:DeepSkyBlue;">Giden Arama:</b> 13/06/2020 tarihinde arandı
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b style="background-color:DeepSkyBlue;">Giden Arama:</b> 13/06/2020 tarihinde arandı
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b style="background-color:DeepSkyBlue;">Giden Arama:</b> 13/06/2020 tarihinde arandı
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b style="background-color:DeepSkyBlue;">Giden Arama:</b> 13/06/2020 tarihinde arandı
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b style="background-color:DeepSkyBlue;">Giden Arama:</b> 13/06/2020 tarihinde arandı
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import { repository } from "@/_services/repository.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import StarRating from "vue-star-rating";

export default {
  components: {
    StarRating,
    VuePerfectScrollbar,
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        suppressScrollX: true,
      },
      viewData: {},
      sampleData: [
        { name: "S0001", val: ["3000 TL", "Nakit", "05/06/2020 15:45", "yok"] },
        {
          name: "S0002",
          val: ["5000 TL", "Havale", "05/06/2020 15:45", "yok"],
        },
        {
          name: "S0003",
          val: ["4000 TL", "Kredikartı", "05/06/2020 15:45", "yok"],
        },
      ],
    };
  },

  methods: {
    beautifyAmount(){
      let str="<div class='amount-container'><span class='amount'>Tedarikçi:</span>";
      this.viewData=repository.convertToJSON(this.viewData,"realAmount");
      if(this.viewData.realAmount){
        for(let i=0;i<this.viewData.realAmount.length;i++){
          if(this.viewData.realAmount[i].IO=="I")
            str+="<span class='amount "+(this.viewData.realAmount[i].amount>0?"red":"")+"'>"+
            (this.viewData.realAmount[i].amount.toFixed(2)) + this.viewData.realAmount[i].currency 
            + "</span>";
        }
        str+="</div><div class='amount-container'><span class='amount'>Müşteri:</span>";

        for(let i=0;i<this.viewData.realAmount.length;i++){
          if(this.viewData.realAmount[i].IO=="O")
            str+="<span class='amount "+(this.viewData.realAmount[i].amount<0?"red":"")+"'>" + (this.viewData.realAmount[i].amount.toFixed(2)) + this.viewData.realAmount[i].currency + "</span>";
        }
      }
      str+="</div>";
      document.getElementById("amount").innerHTML=str;
    },
    beautifyPhone() {
      
        return (
          "https://api.whatsapp.com/send?phone=" +
         this.viewData.phone
        );
    
    },
    setRating: function (rating) {
      this.$vs.notify({
        title: "Müşteri Yıldızları",
        text: `Müşteriye ${rating} puan verildi.`,
      });
    },
    confirmHireRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `İşten Çıkar`,
        text: `"${this.viewData.name}" işten çıkartmak istediğinize emin misiniz?`,
        accept: this.hireRecord,
        acceptText: "Çıkar",
        cancelText: "Vazgeç",
      });
    },
    hireRecord() {
      //
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Silme İşlemi`,
        text: `"${this.viewData.name}" Silmek istediğinize emin misiniz?`,
        accept: this.deleteRecord,
        acceptText: "Sil",
        cancelText: "Vazgeç",
      });
    },
    deleteRecord: async function () {
      //repository.deleteEntity("User/deleteUser", this.viewData.uId);

      //this.$router.push("/userList");
      this.$vs.notify({
        color: "success",
        title: "Personel Silindi",
        text: `"${this.viewData.name}" Başarıyla silindi.`,
      });
    },
  },
  created() {
    const customerId = this.$route.params.customerId;
    repository.getById("Customer/getById", customerId).then((r) => {
      this.viewData = r.list[0];
      this.beautifyAmount();
    });
  },
};
</script>

<style lang="scss" scoped>
.vue-star-rating-rating-text {
  display: none;
}
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
.amount-container{
  margin-bottom: 5px;
}
.amount{
  margin-right: 10px;
  font-weight: bolder;
}
.amount.red{
  color:red;
}
.tableHeight {
  height: 170px;
  th,
  td {
    height: 40px !important;
  }
}
</style>
